import Icon from './Icon.tsx';
import { ComposedIconProps } from './Icon.tsx';
import url from '@assets/images/alert.svg';

const AlertIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default AlertIcon;
